import axios from '../../axios'

/*
 * 材料数据接口
 */
// 获取公众号分页查询
export const getAccountsList = (data) => {
    return axios({
        url: '/api/base/official/accounts/page',
        method: 'get',
        data
    })
}

// 公众号id查询
export const getAccountsId = (data) => {
    return axios({
        url: '/api/base/official/accounts/get',
        method: 'get',
        data
    })
}
// 公众号新增
export const addAccounts = (data) => {
    return axios({
        url: '/api/base/official/accounts',
        method: 'post',
        data
    })
}

// 公众号更新
export const updateAccounts = (data) => {
    return axios({
        url: '/api/base/official/accounts',
        method: 'put',
        data
    })
}

// 公众号删除
export const deleteAccounts = (data) => {
    return axios({
        url: '/api/base/official/accounts',
        method: 'delete',
        data
    })
}
// 公众号扫描
export const testAccounts = (data) => {
    return axios({
        url: '/api/base/remote/official/accounts/scan',
        method: 'post',
        data
    })
}



// WEBPACK FOOTER //
// ./src/http/moudules/reptile/accounts.js